module.exports = __webpack_public_path__ + "img/header-bg.20a25cb0.png";